import axios from 'axios'
import {
  getSessionToken,clearSessionValues
} from '../utils/helper'

const service = axios.create({})
service.interceptors.request.use(
  (config) => {
     if (!config.data) {
      config.headers['Content-Type'] = ''
    }
    config.headers['Heco-Authorization'] = getSessionToken()
    return config
  },
  (error) => {
    console.debug(error)
    Promise.reject(error)
  },
)
service.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      clearSessionValues()
      window.location = '/'
    }
    return Promise.reject(error.response)
  },
)
export default service
